import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Carousel } from 'react-bootstrap';

import * as styles from '../../styles/modules/gallery-main.module.scss'
import { trackEvent } from '../../utils/umami';

type GalleryProps = {
    data: any;
    title: string;
}

const Gallery = ({ data, title }: GalleryProps) => {
    const getRows = (items: any[]) => {
        let rows = []
        for (let i = 0; i < items.length; i += 3) {
            let row = [];
            row.push(items[i]);
            if (items.length > i + 1) row.push(items[i + 1]);
            if (items.length > i + 2) row.push(items[i + 2]);
            rows.push(row);
        }
        return rows;
    };

    return (
        <div className={styles.gallery}>
            <h1>{title}</h1>
            <p style={{ textAlign: 'center', fontSize: '0.8rem' }}>Click a cover photo to see more images from that project.</p>
            <div className="copy-width">
                <div className={styles.grid}>
                    {
                        getRows(data.allMdx.edges).map((row, index) => (
                            <div className={styles.gridRow} key={`row-${index}`}>
                                {
                                    row.map((album, idx) => (
                                        <React.Fragment key={`row-${index}-gallery-${idx}`}>
                                            <GatsbyImage className={styles.cover} alt={`Row ${index} Gallery ${idx} cover`} image={getImage(album.node.frontmatter.cover)} tabIndex={-1} onClick={() => trackEvent('gallery-album-open', { gallery: title, album_index: index * 3 + idx })} />
                                            <Carousel className={styles.slideshow}>
                                                {
                                                    album.node.frontmatter.images.map((img, i) => (
                                                        <Carousel.Item key={`row-${index}-gallery-${idx}-img-${i}`}>
                                                            <GatsbyImage alt={`Row ${index} Gallery ${idx} Slide ${i}`} image={getImage(img.image)} />
                                                            { img.caption && <Carousel.Caption>{img.caption}</Carousel.Caption>}
                                                        </Carousel.Item>
                                                    ))
                                                }
                                            </Carousel>
                                        </React.Fragment>
                                    ))
                                }
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    );
};

export default Gallery;
